import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { NO_VALUE } from '../../../../../../../lib/utils/utilsTypes';

/**
 * Returns true if at least one of the redistribution filters for calculation is set
 */
export const useIsRedistributionFilterSet = (): boolean => {
  const redistributionFilterBrandId = useSelector(
    state => state.calculations.redistributionFilterBrandId,
  );
  const redistributionFilterOutOfStock = useSelector(
    state => state.calculations.redistributionFilterOutOfStock,
  );
  const redistributionFilterForced = useSelector(
    state => state.calculations.redistributionFilterForced,
  );

  const redistributionFilterSourceSkuClassIds = useSelector(
    state => state.calculations.redistributionFilterSourceSkuClassIds,
  );
  const redistributionFilterTargetSkuClassIds = useSelector(
    state => state.calculations.redistributionFilterTargetSkuClassIds,
  );

  return useMemo(() => {
    if (redistributionFilterBrandId !== undefined && redistributionFilterBrandId !== NO_VALUE) {
      return true;
    }

    if (redistributionFilterSourceSkuClassIds.length > 0) {
      return true;
    }

    if (redistributionFilterTargetSkuClassIds.length > 0) {
      return true;
    }

    if (redistributionFilterOutOfStock) {
      return true;
    }

    return redistributionFilterForced;
  }, [
    redistributionFilterBrandId,
    redistributionFilterForced,
    redistributionFilterOutOfStock,
    redistributionFilterSourceSkuClassIds,
    redistributionFilterTargetSkuClassIds,
  ]);
};
